<template>
  <Carousel class="special-commision-offer-card-list">
    <SpecialCommisionOfferCard
      v-for="offer in offers"
      :key="offer.dealId"
      :offer="offer"
      @continue="onContinueOffer(offer, $event)"
    />
  </Carousel>
</template>

<script>
import { Carousel } from '@n11/so-ui-components';
import SpecialCommisionOfferCard from '@/components/SpecialCommisionOfferCard/SpecialCommisionOfferCard';
import { getSpecialCommisionOffersAsync } from '@/views/ProductDeal/services/productDealService';

export default {
  name: 'SpecialCommisionOfferCardList',
  components: {
    Carousel,
    SpecialCommisionOfferCard,
  },
  emits: ['visibility-change'],
  data() {
    return {
      offers: [],
    };
  },
  mounted() {
    this.fetchSpecialCommisionOffers();
  },
  methods: {
    async fetchSpecialCommisionOffers() {
      try {
        const response = await getSpecialCommisionOffersAsync();
        if (response.error) {
          this.$emit('visibility-change', false);
          return;
        }
        this.offers = response.visible ? response.data : [];
        this.$emit('visibility-change', {
          visible: this.offers.length > 0,
          offers: this.offers,
        });
      } catch (error) {
        console.error('Error fetching special commission offers:', error);
        this.$emit('visibility-change', false);
      }
    },
    onContinueOffer(offer, selection) {
      this.$store.commit('productDeal/SET_PENDING_DEAL_OFFER_ACTION', {
        dealId: offer.dealId,
        productId: offer.productId,
        offerKey: selection.offerKey,
        newSalesPrice: selection.price,
        commission: selection.commission,
        source: 'specialCommissionDashboard',
        dealDetails: offer,
        viewPromotionParams: selection.viewPromotionParams,
      });
      this.$router.push({
        name: 'ProductDeal'
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.special-commision-offer-card-list {
  margin-top: 16px;
  margin-left: -24px;
  margin-right: -24px;

  :deep(.special-commision-offer-card) {
    &:first-child {
      margin-left: 24px;
    }

    &:last-child {
      margin-right: 24px;
    }
  }

  :deep(.carousel-arrow) {
    &.left {
      left: 5px !important;
    }

    &.right {
      right: 5px !important;
    }
  }
}
</style>
